<template>
  <div class="d-flex flex-column px-6 py-6" style="gap: 14px">
    <div>
      <v-alert outlined dense border="left" color="blue" v-if="auto.sne_na">
        <div class="d-flex align-content-center">
          <v-img :src="sne_img" max-width="44px" class="d-inline-block mr-3" />
          <span>
            <b>Notificação de Autuação</b> foi emitida na modalidade <b>SNE.</b>
          </span>
        </div>
      </v-alert>
      <v-alert outlined dense border="left" color="blue" v-if="auto.sne_np">
        <div class="d-flex align-content-center">
          <v-img :src="sne_img" max-width="44px" class="d-inline-block mr-3" />
          <span>
            <b>Notificação de Penalidade</b> foi emitida na modalidade
            <b>SNE.</b>
          </span>
        </div>
      </v-alert>
      <v-alert outlined dense border="left" color="blue" v-if="arquivo_na">
        <v-img
          :src="correios_img"
          width="84px"
          contain
          class="d-inline-block mr-3"
        />
        <b>Notificação de Autuação</b> expedida em
        <b>{{ arquivo_na.data_postagem | data }}</b> no lote
        <b>{{ arquivo_na.numero_lote }}.</b>
      </v-alert>
      <v-alert outlined dense border="left" color="blue" v-if="arquivo_np">
        <v-img
          :src="correios_img"
          width="84px"
          contain
          class="d-inline-block mr-3"
        />
        <b>Notificação de Penalidade</b> expedida em
        <b>{{ arquivo_np.data_postagem | data }}</b> no lote
        <b>{{ arquivo_np.numero_lote }}.</b>
      </v-alert>
      <v-alert
        outlined
        prominent
        type="error"
        border="left"
        v-if="auto.status.descricao == 'Cancelado'"
      >
        <b>Justificativa cancelamento:</b>
        {{
          auto.justificativa_cancelamento ||
            "A justificafiva não consta no sistema."
        }}
      </v-alert>
    </div>

    <!-- Detalhes -->
    <div>
      <v-row class="mb-1">
        <v-col><span class="text-h6">Auto</span></v-col>
      </v-row>

      <v-row no-gutters>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Número:</span>
            <span>{{ auto.numero_auto }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Situação:</span>
            <span>{{ auto.status.descricao }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">RENAINF:</span>
            <span>{{ auto.renainf || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Origem:</span>
            <span>{{ auto.origem.descricao }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Unidade autuadora:</span>
            <span>{{ getAutoOrigem(auto.origem) }}</span>
          </div>
        </v-col>

        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Data da infração:</span>
            <span>{{ auto.data_infracao | dateTimeBR }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Data limite do recurso:</span>
            <span>{{ auto.recurso_limite | data }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">
              Data limite da defesa prévia:
            </span>
            <span>{{ auto.defesa_limite | data }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">
              Atualizado com Detran:
            </span>
            <span v-if="auto.atualizado_api_detran">
              {{ auto.atualizado_api_detran | data }}
            </span>
            <span v-else>
              Nunca
            </span>
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col md="12" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Órgão autuador:</span>
            <span>213890 - AUTARQUIA MUNICIPAL DE TRÂNSITO E CIDADANIA</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <!-- Detalhes -->

    <!-- Veiculo -->
    <div v-if="!auto.suv">
      <v-row class="mb-1">
        <v-col><span class="text-h6">Veículo</span></v-col>
      </v-row>

      <v-row no-gutters>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Placa:</span>
            <span>{{ auto.veiculo.placa || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Chassi:</span>
            <span>{{ auto.veiculo.chassi || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Marca/Modelo:</span>
            <span>{{ auto.veiculo.marca_modelo || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">UF:</span>
            <span>{{ auto.veiculo.uf || "-" }}</span>
          </div>
        </v-col>

        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Cor:</span>
            <span>{{ auto.veiculo.cor || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Tipo:</span>
            <span>{{ auto.veiculo.tipo || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Espécie:</span>
            <span>{{ auto.veiculo.especie || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Ano fabricação:</span>
            <span>{{ auto.veiculo.ano_fabricacao || "-" }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-divider v-if="!auto.suv"></v-divider>
    <!-- Veiculo -->

    <!-- Local -->
    <div>
      <v-row class="mb-1">
        <v-col><span class="text-h6">Local da infração</span></v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Local:</span>
            <span>{{ auto.infracao.logradouro }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Complemento:</span>
            <span>{{ auto.infracao.complemento || "-" }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <!-- Local -->

    <!-- Proprietario -->
    <div>
      <v-row class="mb-1">
        <v-col
          ><span class="text-h6">{{
            auto.suv ? "Infrator" : "Proprietário do veículo"
          }}</span></v-col
        >
      </v-row>

      <v-row no-gutters>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Nome:</span>
            <span>{{ auto.proprietario.nome || "-" }}</span>
          </div>
        </v-col>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">CPF/CNPJ:</span>
            <span>{{ auto.proprietario.cpf | cpf }}</span>
          </div>
        </v-col>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Endereço:</span>
            <span>{{
              `${auto.proprietario.logradouro || "-"}, ${auto.proprietario
                .numero || "-"}`
            }}</span>
          </div>
        </v-col>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Bairro:</span>
            <span>{{ auto.proprietario.bairro || "-" }}</span>
          </div>
        </v-col>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Complemento:</span>
            <span>{{ auto.proprietario.complemento || "-" }}</span>
          </div>
        </v-col>
        <v-col md="2" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">CEP:</span>
            <span>{{ auto.proprietario.cep || "-" }}</span>
          </div>
        </v-col>
        <v-col md="3" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Municipio:</span>
            <span>{{ auto.proprietario.municipio || "-" }}</span>
          </div>
        </v-col>
        <v-col md="1" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">UF:</span>
            <span>{{ auto.proprietario.uf || "-" }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <!-- Proprietario -->

    <!-- Condutor -->
    <div v-if="!auto.suv">
      <v-row class="mb-1">
        <v-col><span class="text-h6">Condutor do veículo</span></v-col>
      </v-row>

      <v-alert
        outlined
        type="info"
        border="left"
        v-if="auto.condutor_situacao == '9' && auto.processo"
      >
        Condutor indicado no processo
        <b>{{ auto.processo.cod_processo }}</b> em
        <b>{{ auto.processo.created_at | data }}.</b>
      </v-alert>

      <v-alert outlined type="warning" border="left" v-if="!auto.condutor.nome">
        Condutor não identificado.
      </v-alert>

      <v-row v-if="auto.condutor.nome" no-gutters>
        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Nome:</span>
            <span>{{ auto.condutor.nome || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">CPF:</span>
            <span>{{ auto.condutor.cpf | cpf }}</span>
          </div>
        </v-col>

        <v-col md="6" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Registro CNH:</span>
            <span>{{ auto.condutor.cnh || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Categoria CNH:</span>
            <span>{{ auto.condutor.tipo_documento || "-" }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-divider v-if="!auto.suv"></v-divider>
    <!-- Condutor -->

    <!-- Infração -->
    <div>
      <v-row class="mb-1">
        <v-col><span class="text-h6">Tipificação da infração</span></v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" md="5">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Matrícula do agente:</span>
            <span>{{ auto.agente_codigo }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Código infração:</span>
            <span>
              {{ auto.infracao.codigo }}
              {{ auto.infracao.digito && ` - ${auto.infracao.digito}` }}
            </span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Artigo (CTB):</span>
            <span>{{ auto.infracao.amparo }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Gravidade:</span>
            <span>{{ auto.infracao.categoria || "-" }}</span>
          </div>
        </v-col>

        <v-col cols="12" md="7" v-if="auto.infracao.equipamento_utilizado">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Equipamento utilizado:</span>
            <span>{{ auto.infracao.equipamento_utilizado || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Medição realizada:</span>
            <span>
              {{ auto.infracao.medicao_realizada || "-" }}
            </span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Limite regulamentado:</span>
            <span>{{ auto.infracao.limite_regulamentado || "-" }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Valor considerado:</span>
            <span>{{ auto.infracao.valor_considerado || "-" }}</span>
          </div>
        </v-col>

        <v-col cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Descrição:</span>
            <span>{{ auto.infracao.descricao_breve }}</span>
          </div>
          <p class="mb-0">
            <span class="font-weight-bold pr-1">Observação:</span>
            {{ auto.observacao }}
          </p>
          <p class="mb-0" v-if="auto.suv">
            <span class="font-weight-bold pr-1">Informações adicionais:</span>
            {{ auto.informacoes_adicionais || "-" }}
          </p>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <!-- Infração -->

    <!-- Pagamento -->
    <div>
      <v-row class="mb-1">
        <v-col><span class="text-h6">Pagamento</span></v-col>
      </v-row>

      <v-alert outlined type="info" border="left" v-if="!auto.data_pagamento">
        Pagamento ainda não foi identificado.
      </v-alert>

      <v-row no-gutters>
        <v-col v-if="auto.data_pagamento" cols="12">
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Valor da infração:</span>
            <span>{{ auto.valor_agravado_infracao | dinheiro }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Valor pago:</span>
            <span>{{ auto.valor_pagamento | dinheiro }}</span>
          </div>
          <div class="d-flex">
            <span class="font-weight-bold pr-1">Data do pagamento:</span>
            <span>{{ auto.data_pagamento | data }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <!-- Pagamento -->
  </div>
</template>
<script>
export default {
  name: "DadosGerais",
  props: {
    auto: {
      type: Object,
      default: () => {},
    },
    arquivo_na: {
      type: Object,
      default: () => {},
    },
    arquivo_np: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      correios_img: require("@/assets/img/correios.jpeg"),
      sne_img: require("@/assets/img/sne.png"),
    };
  },

  filters: {
    dateTimeBR: function(data) {
      const arrData = data.split(" ");

      return `${arrData[0]
        .split("-")
        .reverse()
        .join("/")} ${arrData[1]}`;
    },
  },

  methods: {
    getAutoOrigem(origem) {
      if ([5, 6, 7].indexOf(origem.id) !== -1) {
        return "AMC";
      }
      return origem.descricao;
    },
  },
};
</script>
